// extracted by mini-css-extract-plugin
export var nav = "navigation-module--nav--X6P3B";